import { MinLength } from 'class-validator';

export class UpdateBlueMediaPaymentStatusModel {
  @MinLength(16)
  public orderId: string;

  @MinLength(16)
  public hash: string;
}
